/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/alt-text */
import React, { Fragment, PureComponent } from 'react';
import { shopContext } from '../../contexts/aniplus';
import { withRouter } from 'react-router-dom';
// import axios from "axios";

// import { ToastContainer, toast } from "react-toastify"; //토스트(toast)
// import { confirmAlert } from "react-confirm-alert"; //알럿창(alert confirm)

import $ from 'jquery';
import '../../slick.js';
class StoreInfoBusanItem extends PureComponent {
  componentDidMount = () => {
    //매장 정보 슬라이드
    $('.store_info_slide').slick({
      slide: '.store_info_img',
      slidesToShow: 1,
      slidesToScroll: 1,
      fade: true,
      infinite: true,
      autoplay: true,
      autoplaySpeed: 5000,
      prevArrow: false,
      nextArrow: false,
      dots: true,
    });
    //매장정보 평면도 슬라이드 이동 버튼
    $('.store_plan .map a').on('click', function (e) {
      var slideno = $(this).data('slide');
      $('.store_info_slide').slick('slickGoTo', slideno - 1);
    });
    //매장정보 평면도 슬라이드 매핑
    $('.store_info_slide').on(
      'afterChange',
      function (event, slick, currentSlide) {
        if ($('.store_info_img').hasClass('slick-current')) {
          var floorCurrent = $(
            '.store_plan .map a[data-slide=' + (currentSlide + 1) + ']'
          ).data('floor-plan');
          $('.floor_plan').attr(
            'src',
            '/img/store/info_' + floorCurrent + '.png'
          );
        }
      }
    );
    //매장 정보 평면도 클릭 시 이미지 변경 - 즉각 반응 위해 추가
    $('.store_plan .map a').on('click', function () {
      var floorPlan = $(this).data('floor-plan');
      $('.floor_plan').attr('src', '/img/store/info_' + floorPlan + '.png');
    });
  };
  componentWillUnmount = () => {
    $('.store_info_slide').off('afterChange');
  };
  render() {
    const { imgUrl } = this.props;

    return (
      <Fragment>
        <div className="store_slide_wrap">
          {/* 매장 도면 */}
          <div className="store_plan_wrap">
            <input type="checkbox" id="btn_floor_plan" />
            <label className="btn_floor_plan" htmlFor="btn_floor_plan">
              평면도 버튼
            </label>
            <div className="store_floor_plan">
              <div className="store_plan">
                <div className="plan_tit">
                  <p className="tit">부산 서면점 평면도</p>
                  <p className="dsc">
                    원하시는 영역을 클릭하시면 해당 사진을 보실 수 있습니다.
                  </p>
                </div>
                <div className="map busan">
                  <a data-floor-plan="map4_1" data-slide="1">
                    A
                  </a>
                  <a data-floor-plan="map4_2" data-slide="2">
                    B
                  </a>
                  <a data-floor-plan="map4_3" data-slide="3">
                    C
                  </a>
                  <a data-floor-plan="map4_4" data-slide="4">
                    D
                  </a>
                  <a data-floor-plan="map4_5" data-slide="5">
                    E
                  </a>
                  <a data-floor-plan="map4_6" data-slide="6">
                    F
                  </a>
                  <a data-floor-plan="map4_7" data-slide="7">
                    G
                  </a>
                  <a data-floor-plan="map4_8" data-slide="8">
                    H
                  </a>
                  <a data-floor-plan="map4_9" data-slide="9">
                    I
                  </a>
                  <a data-floor-plan="map4_10" data-slide="10">
                    J
                  </a>
                  <img
                    src={imgUrl + '/img/store/info_map4_1.png'}
                    className="floor_plan"
                  />
                </div>
              </div>
            </div>
          </div>
          {/* 매장 이미지 슬라이드 */}
          <div className="store_info_slide">
            <div className="store_info_img">
              <img
                src={imgUrl + '/img/store/info4_img01.png'}
                className="img_web"
              />
              <img
                src={imgUrl + '/img/store/info4_img01_m.png'}
                className="img_m"
              />
            </div>
            <div className="store_info_img">
              <img
                src={imgUrl + '/img/store/info4_img02.png'}
                className="img_web"
              />
              <img
                src={imgUrl + '/img/store/info4_img02_m.png'}
                className="img_m"
              />
            </div>
            <div className="store_info_img">
              <img
                src={imgUrl + '/img/store/info4_img03.png'}
                className="img_web"
              />
              <img
                src={imgUrl + '/img/store/info4_img03_m.png'}
                className="img_m"
              />
            </div>
            <div className="store_info_img">
              <img
                src={imgUrl + '/img/store/info4_img04.png'}
                className="img_web"
              />
              <img
                src={imgUrl + '/img/store/info4_img04_m.png'}
                className="img_m"
              />
            </div>
            <div className="store_info_img">
              <img
                src={imgUrl + '/img/store/info4_img05.png'}
                className="img_web"
              />
              <img
                src={imgUrl + '/img/store/info4_img05_m.png'}
                className="img_m"
              />
            </div>
            <div className="store_info_img">
              <img
                src={imgUrl + '/img/store/info4_img06.png'}
                className="img_web"
              />
              <img
                src={imgUrl + '/img/store/info4_img06_m.png'}
                className="img_m"
              />
            </div>
            <div className="store_info_img">
              <img
                src={imgUrl + '/img/store/info4_img07.png'}
                className="img_web"
              />
              <img
                src={imgUrl + '/img/store/info4_img07_m.png'}
                className="img_m"
              />
            </div>
            <div className="store_info_img">
              <img
                src={imgUrl + '/img/store/info4_img08.png'}
                className="img_web"
              />
              <img
                src={imgUrl + '/img/store/info4_img08_m.png'}
                className="img_m"
              />
            </div>
            <div className="store_info_img">
              <img
                src={imgUrl + '/img/store/info4_img09.png'}
                className="img_web"
              />
              <img
                src={imgUrl + '/img/store/info4_img09_m.png'}
                className="img_m"
              />
            </div>
            <div className="store_info_img">
              <img
                src={imgUrl + '/img/store/info4_img10.png'}
                className="img_web"
              />
              <img
                src={imgUrl + '/img/store/info4_img10_m.png'}
                className="img_m"
              />
            </div>
          </div>
        </div>
        {/* 매장 주소 */}
        <div className="store_addr">
          <dl>
            <dt>
              <img src={imgUrl + '/img/store/ico_address_txt.png'} />
            </dt>
            <dd>부산시 부산진구 중앙대로 672 삼정타워 9층 </dd>
          </dl>
          <dl>
            <dt>
              <img src={imgUrl + '/img/store/ico_qna_txt.png'} />
            </dt>
            <dd>070-7162-7048</dd>
          </dl>
          <dl>
            <dt>
              <img src={imgUrl + '/img/store/ico_email_txt.png'} />
            </dt>
            <dd>webmaster2@aniplustv.com</dd>
          </dl>
          <dl>
            <dt>
              <img src={imgUrl + '/img/store/ico_hours_txt.png'} />
            </dt>
            <dd>오전 11:00 ~ 오후 10:00(연중무휴)</dd>
          </dl>
        </div>
      </Fragment>
    );
  }
}
export default shopContext(withRouter(React.memo(StoreInfoBusanItem)));
